import React, { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Modal } from "reactstrap";
import "./styles.scss";
import { useDispatch } from "react-redux";
import axios from "axios";

import { fetchSellers } from "../../slices/sellerSlice";
const Address = (props) => {
    const dispatch = useDispatch();
    const [pincode, setPincode] = useState('');
    const [error, setError] = useState("");
    const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"))
    const [loading, setLoading] = useState(false);

    const validatePincode = async (pin) => {
        const pincodeRegex = /^\d{6}$/; // Regex to match exactly 6 digits
        if (!pin) {
            return "Please enter a pincode";
        } else if (!pincodeRegex.test(pin)) {
            return "Please enter a valid 6-digit pincode";
        }
        return "";
    };

    const handlePincodeChange = (e) => {
        const inputPin = e.target.value;
        setPincode(inputPin);
    };

    const findCoordinates = async () => {
        const errorMessage = await validatePincode(pincode);
        setError(errorMessage);
        if (errorMessage.length !== 0) {
            return
        }
        setLoading(true)
        const apiUrl = `https://nominatim.openstreetmap.org/search?postalcode=${pincode}&format=json`;
        fetch(apiUrl)
            .then((response) => response.json())
            .then(async(data) => {
                if (data.length > 0) {
                    const { lat, lon } = data[0];
                    const defaultAddress = {
                        latitude: lat,
                        longitude: lon,
                        zipcode: pincode
                    }
                    localStorage.setItem('defaultAddress', JSON.stringify(defaultAddress));
                    if (props?.setPincode) {
                        props.setShowPreLoginAddessModal(false);
                        props?.setPincode(pincode)
                        setLoading(false)
                        return;
                    }
                    setLoading(false)
                    dispatch(
                        fetchSellers({
                            latitude: lat,
                            longitude: lon,
                            areaCode: pincode,
                        }))
                    props.setShowPreLoginAddessModal(false);

                } else {
                    const options = {
                        method: "post",
                        url: `${process.env.REACT_APP_KIKO_API_BASE_URL_v3}/api/v1/maps/autocomplete-v2-ola`,
                        headers: {
                        // Authorization: `${token}`,
                        desktop: true,
                        },
                        data: { search: pincode, token: "" },
                    };
                    const res = await axios(options);
                    if (res?.data?.success) {
                    const { lat, lng } = res?.data?.data[0]?.geometry?.location;
                    const defaultAddress = {
                        latitude: lat,
                        longitude: lng,
                        zipcode: pincode
                    }
                    localStorage.setItem('defaultAddress', JSON.stringify(defaultAddress));
                    if (props?.setPincode) {
                        props.setShowPreLoginAddessModal(false);
                        props?.setPincode(pincode)
                        setLoading(false)
                        return;
                    }
                    setLoading(false)
                    dispatch(
                        fetchSellers({
                            latitude: lat,
                            longitude: lng,
                            areaCode: pincode,
                        }))
                    props.setShowPreLoginAddessModal(false);
                    }else{
                        setError("No coordinates found for the provided pincode.")
                        setLoading(false)
                    }
                }
            })
            .catch((error) => {
                setError("Error fetching coordinates")
                console.error('Error fetching coordinates:', error);
            });
    };

    return (
        <Modal
            isOpen={props.showPreLoginAddessModal}
            aria-labelledby="contained-modal-title-vcenter"
            contentLabel="Address Modal "
            centered
            className="custom-modal-kl"
        >
            <div className="custom-modal-header-kl">
                <div className="custom-modal-title-kl">Enter Your Pincode</div>
                {
                    defaultAddress &&
                    <button className="close-icon-kl"
                        onClick={() => {
                            props.setShowPreLoginAddessModal(false);
                        }}
                    ></button>

                }
            </div>
            <div className="custom-modal-body-kl ">
                <div className="addressmodal-block-kl">
                    <div className="searchBlock">
                        <div className="input-error-wrapper">
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Enter your pincode"
                                value={pincode}
                                onChange={handlePincodeChange}
                                maxLength={6}
                            />
                            {error.length > 0 && <p className="error">{error}</p>}
                        </div>
                    </div>
                    <button
                        className="pin-code-enter-btn w-100"
                        type="button"
                        onClick={findCoordinates}
                        disabled={loading}
                        style={{
                            marginBottom: "0px",
                        }}
                    >
                        {loading ? "Please Wait" : "Submit"}
                    </button>
                </div>
            </div>

        </Modal>
    );
};
export default Address;
